

















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'
import ProfileAPI from '@/api/modules/profile.api'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  metaInfo: {
    title: 'Developers',
  },

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      apiKey: '',
    }
  },

  computed: {
    apiKeyHydrated(): boolean {
      return this.apiKey !== ''
    },
  },

  methods: {
    async hydrateAPIKey() {
      try {
        const response = await ProfileAPI.get_APIKey()
        this.apiKey = response.key
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
